import state from './state.controlTower'
import mutations from './mutations.controlTower'
import actions from './actions.controlTower'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}